<main class="alg-workflow-process-detail">
  <alg-view-process [processId]="processId"></alg-view-process>
</main>
